import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/industries/healthcare/components/HealthcareView.tsx");
